import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-layout__header is-sticky" }
const _hoisted_2 = { "data-qa": "main-navbar" }
const _hoisted_3 = { class: "gfu-header__navbar gfu-navbar gfu-navbar--lighter _flex _jc-sb" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_navigation_bar = _resolveComponent("top-navigation-bar")
  const _component_header_logo = _resolveComponent("header-logo")
  const _component_header_auth_actions = _resolveComponent("header-auth-actions")
  const _component_search_form = _resolveComponent("search-form")
  const _component_header_actions = _resolveComponent("header-actions")
  const _component_user_location_bar = _resolveComponent("user-location-bar")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_top_navigation_bar, { "project-id": $props.projectId }, null, 8 /* PROPS */, ["project-id"])
    ]),
    _createElementVNode("div", {
      id: "js-main-header",
      ref: "mainHeader",
      class: _normalizeClass(['gfu-layout__header', $options.layoutModeClass])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['gfu-header', $options.layoutModeClass])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_header_logo),
            ($options.isAuth)
              ? (_openBlock(), _createBlock(_component_header_auth_actions, {
                  key: 0,
                  "action-type": $props.authActionType,
                  "intro-text": $props.authIntroText
                }, null, 8 /* PROPS */, ["action-type", "intro-text"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_search_form),
                  _createVNode(_component_header_actions)
                ], 64 /* STABLE_FRAGMENT */))
          ]),
          ($props.isUserLocationBarVisible)
            ? (_openBlock(), _createBlock(_component_user_location_bar, { key: 0 }))
            : _createCommentVNode("v-if", true)
        ])
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}